/* eslint-disable react/prop-types */
import React from "react";
import { updateCallback } from "../../../hooks/update-hooks/update-callbacks/update-callback";
import { toast } from "react-toastify";

const lostReasonConstants = {
    PRX_LOST: {
        OUTDATED: "Outdated",
        SINGLE_ITEM: "Single Item",
        NOT_CLEAR: "Not Clear",
        RE_ORDER: "Re Order",
        EXTRA_CHARGES_DENIED: "Extra Charges Denied",
        ONLINE_SALES_PROHIBITED: "Online Sales Prohibited",
        GENERIC_ITEMS: "Generic Items",
        REGION_SPECIFIC_ITEMS: "Region Specific Items",
        SUBSTITUTES_ABAILABLE: "Substitutes Available",
        REPEATED_PRX: "Repeated PRX",
        HAS_STOCK_AND_LOW_PROSPECT: "Has Stock and Low Prospect",
        PINCODE_UNSERVICABLE: "Pincode Unservicable",
        NA: "NA",
    },
    QUOTE_REJECTED: {
        DISCOUNT_UNACCEPTABLE: "Discount Unacceptable",
        PROHIBITED_ITEMS_REQUIRED: "Prohibited Items Required",
        NO_RESPONSE_TO_QUOTE_SENT: "No Response to Quote Sent",
        PRICE_COMPARISON_ONLY: "Price Comparison Only",
        SUBSTITUTE_BRAND_DENIED: "Substitute Brand Denied",
        NA: "NA",
    },
}

function LostReasonDropdown({ callback, refetch }) {
    const [selctedStatus, setSelctedStatus] = React.useState(callback?.additionalDetails?.lostReason);
    const lost = callback?.additionalDetails?.lost

    const changeStatus = async (e) => {
        if (!lost || lost === "NA") {
            return toast.error("Please select lost reason");
        }

        setSelctedStatus(e.currentTarget.value);
        let additionalDetails = callback?.additionalDetails
        additionalDetails.lostReason = e.currentTarget.value
        callback.additionalDetails = additionalDetails;
        try {
            await updateCallback({
                additionalDetails
            }, parseInt(callback.id))
            refetch()
        } catch (error) {
            toast.error(error)
        }

    }
    return (
        <select disabled={!lost || lost === "NA"} className="bg-white-50 rounded-md w-[120px] h-10 font-medium" onChange={(e) => changeStatus(e)} value={selctedStatus} name="status" id="status">
            {lost && lost !== "NA" && Object.keys(lostReasonConstants[lost])?.map((reason) => (
                <option value={reason} key={reason}>{lostReasonConstants[lost][reason]}</option>
            ))}
        </select>
    );


}

export { LostReasonDropdown };